import { ChangeDetectionStrategy, Component } from '@angular/core'

@Component({
	selector: 'app-list-page-layout',
	standalone: true,
	templateUrl: './list-page-layout.component.html',
	styleUrl: './list-page-layout.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ListPageLayoutComponent {}
